// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  mapbox: {
    accessToken: 'pk.eyJ1Ijoidm9sYXJlY29uc3VsdCIsImEiOiJja2Y1aXEyMHowbmRhMzJrdTExaHAzNnM1In0.IDpH_YLjuWcuaCZY2pS-6Q',
    styles: {
      street: 'mapbox://styles/volareconsult/ckf5iu3pb29kj19mtc8gqqilo',
      satellite: 'mapbox://styles/volareconsult/ckfwuatu70dhu1cod0cbuvpge'
    },
    default: {
      zoom: 10
    }
  },
  manual: {
    url: 'http://127.0.0.1:8000'
  },
  project: {
    uploadPollingDelay: 5000
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
